// src/app/components/ChatCustom/Markdown/remark/rehypeLinkTypes.ts
import type { Plugin } from "unified";
import type { Root, Element } from "hast";
import { visit } from "unist-util-visit";

export const rehypeLinkTypes: Plugin<[], Root> = () => {
  return (tree) => {
    visit(tree, "element", (node: Element, index, parent) => {
      if (!parent || index == null) return;
      if (node.tagName !== "a") return;

      const href = node.properties?.href as string | undefined;
      if (!href) return;

      // link_copy
      const copyMatch = href.match(/^link_copy:(.*)$/);
      if (copyMatch) {
        const realHref = copyMatch[1];
        const replacement: Element = {
          type: "element",
          tagName: "span",
          properties: {
            className:
              "flex items-center justify-between w-full rounded-lg border border-blue-200 bg-blue-50 px-2 py-1 my-1",
          },
          children: [
            {
              type: "element",
              tagName: "a",
              properties: {
                href: realHref,
                target: "_blank",
                rel: "noopener noreferrer",
                className:
                  "font-medium text-blue-700 hover:underline truncate",
              },
              children: node.children,
            },
            {
              type: "element",
              tagName: "button",
              properties: {
                type: "button",
                "data-href": realHref,
                className:
                  "ml-3 flex items-center justify-center p-1 rounded-md bg-blue-400 hover:bg-blue-600 text-white transition border border-blue-600",
                title: "Copiar link",
              },
              children: [
                  {
                    type: "element",
                    tagName: "span",
                    properties: { "data-icon": "copy" },
                    children: [],
                  },
                ],
                
            },
          ],
        };
        parent.children[index] = replacement;
        return;
      }
 


      // .................. agregar mas tipos de enlaces personalizados aquÃ­
    });
  };
};
